"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgRulerOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M9.19 1.69L1.59 9 23 30.4l7.6-7.29zM4.45 9l4.71-4.51L12.64 8l-2.33 2.3 1.42 1.41 2.32-2.33L17.64 13l-2.33 2.3 1.42 1.41 2.32-2.33L22.64 18l-2.33 2.3 1.42 1.41 2.32-2.33 3.7 3.7L23 27.6z" })));
}
exports.default = SvgRulerOutline;
//# sourceMappingURL=RulerOutline.js.map